import React, { Component } from 'react'
import popup from "~/views/Popup/popup";
import { getLocalizedVal } from '~/tools/localization/helpers'

class OverlayItems extends Component {
  state = {
    selected: 0
  }

  selected(i) {
    this.setState({
      selected: i
    })
  }

  componentDidMount() {
    const url = new URLSearchParams(window.location.search);
    if (url && url.get('overlay') && !this.props.subscriptionPlans){
      popup.purchase(this.props.items[this.state.selected], this.props.content, this.props.watchNow, this.props.purchased);
    }
  }

  render() {
    return (
      <div className={`overlay-video ${this.props.bundleOverlay ? 'overlay-bundle' : ''}`}>
        <div className="overlay-title">
          <span>{this.props.title}</span>
        </div>
        { this.props.warning && <div className='warning'>{this.props.warning}</div> }
        <div className="overlay-body">
          <div className="overlay-body-plans">
            {
              this.props.items && this.props.items.map((item, i) => {
                return (
                  <div className={`plan ${(this.state.selected === i) ? 'selected' : ''} `} onClick={(e) => this.selected(i)} key={i}>
                    <div className="side-bar"></div>
                    <div className="plan-body">
                      <p className="title">{item.name}</p>
                    </div>
                  </div>
                )
              })
            }
          </div>
          <div 
            className="overlay-button cta" 
            onClick={() => this.props.subscriptionPlans ? 
            popup.createSubscription(this.props.items[this.state.selected].id, this.props.type) : 
            popup.purchase(this.props.items[this.state.selected], this.props.content, this.props.watchNow, this.props.purchased, this.props.type)}
          >
            <button>{getLocalizedVal(window.settings,'genericMessages', 'continueCta')} { this.props.warning ? getLocalizedVal(window.settings,'genericMessages', 'warningCta') : '' }</button>
          </div>
        </div>
      </div>
    )
  }
}

export default OverlayItems